import React, { useRef, useState } from 'react';
import { db } from './firebase';
import { toast } from 'react-toastify';
import emailjs from '@emailjs/browser';
import PageHero from './componenets/PageHero';
import Reveal from './componenets/Reveal';

export const ContactUs = () => {
  const [fields, setFields] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [loader, setLoader] = useState(false);
  const form = useRef();
  const update = event => {
    const fieldNames = { user_name: 'name', user_email: 'email', user_phone: 'phone', subject: 'subject', message: 'message' };
    setFields(current => ({ ...current, [fieldNames[event.target.name]]: event.target.value }));
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!fields.name || !fields.email || !fields.phone || !fields.message) {
      toast.error('Please complete each required field.');
      return;
    }
    setLoader(true);
    try {
      await Promise.all([
        db.collection('contact-form').add(fields),
        emailjs.sendForm('service_2pg8t3y', 'template_5quw4lm', form.current, 'Ht4x-bJs385J_5CXI'),
      ]);
      toast.success('Thank you. Your message has been sent.');
      setFields({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch (error) {
      console.error('Contact form submission failed:', error);
      toast.error('We could not send your message. Please try again or contact us by phone.');
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="site-page">
      <PageHero eyebrow="Garden of Peace" title="Contact Us" description="Contact us with questions, feedback, or requests for information." image="/images/HomeSlider_7.jpg" compact />
      <section className="site-section">
        <div className="site-container contact-layout">
          <Reveal className="contact-details">
            <p className="site-eyebrow">Contact us</p><h2>Contact Information</h2>
            <p>Our team welcomes your questions and feedback. Complete the form and we will respond as soon as possible.</p>
            <div className="contact-detail"><span><i className="fas fa-phone-alt" aria-hidden="true" /></span><div><small>Phone</small><a href="tel:+16692146771">(669) 214-6771</a></div></div>
            <div className="contact-detail"><span><i className="fas fa-envelope" aria-hidden="true" /></span><div><small>Email</small><a href="mailto:gardenofpeace.usa@gmail.com">gardenofpeace.usa@gmail.com</a></div></div>
            <div className="contact-detail"><span><i className="fas fa-map-marker-alt" aria-hidden="true" /></span><div><small>Property</small><address>17205 S Jasper Sears Road<br />Santa Nella, CA 95322</address></div></div>
          </Reveal>
          <Reveal className="contact-form-card" delay={120}>
            <form onSubmit={handleSubmit} ref={form}>
              <div className="contact-form__heading"><p className="site-eyebrow">Contact form</p><h2>Send Us a Message</h2><p>Fields marked with an asterisk are required.</p></div>
              <div className="form-grid">
                <div className="form-field"><label htmlFor="contact-name">Full name *</label><input id="contact-name" required autoComplete="name" placeholder="Your full name" value={fields.name} onChange={update} name="user_name" /></div>
                <div className="form-field"><label htmlFor="contact-email">Email *</label><input id="contact-email" type="email" required autoComplete="email" placeholder="you@example.com" value={fields.email} onChange={update} name="user_email" /></div>
                <div className="form-field"><label htmlFor="contact-phone">Phone number *</label><input id="contact-phone" type="tel" required autoComplete="tel" placeholder="(555) 555-5555" value={fields.phone} onChange={update} name="user_phone" /></div>
                <div className="form-field"><label htmlFor="contact-subject">Subject</label><input id="contact-subject" placeholder="How can we help?" value={fields.subject} onChange={update} name="subject" /></div>
                <div className="form-field form-field--full"><label htmlFor="contact-message">Message *</label><textarea id="contact-message" required rows="6" placeholder="Write your message here" value={fields.message} onChange={update} name="message" /></div>
              </div>
              <button className="site-button" type="submit" disabled={loader}>{loader ? 'Sending…' : 'Send message'} <span aria-hidden="true">→</span></button>
            </form>
          </Reveal>
        </div>
      </section>
    </div>
  );
};
